import { useForm, zodResolver } from '@mantine/form';
import { z } from 'zod';

import { Customer, DeclarationDocumentsAdditionalFiscalReferenceRole } from '@e-origin/shared';

export const customerPaymentsSchema = z.object({
  payments: z.object({
    methodOfPayment: z.string().optional().nullable(),
    deferredPayment: z.string().optional().nullable(),
    methodOfPaymentVAT: z.string().optional().nullable(),
    deferredPaymentVAT: z.string().optional().nullable(),
    additionalFiscalReference: z.array(
      z.object({
        role: z
          .enum(Object.values(DeclarationDocumentsAdditionalFiscalReferenceRole) as [any, ...any[]])
          .optional()
          .nullable(),
        vatIdentificationNumber: z.string().optional().nullable(),
      }),
    ),
  }),
  personPayingTheCustomDuty: z.object({
    identificationNumber: z.string().optional().nullable(),
  }),
});
export type CustomerViewPaymentsFormValues = z.infer<typeof customerPaymentsSchema>;

export const useCustomerViewPaymentsFormInitializer = ({ customerDetails }) => {
  const buildFormValues = (cd) => {
    const { payments: customerDetailsPayments } = cd || {};

    const customerDetailsInitialValues: Customer = {
      payments: {
        methodOfPayment: customerDetailsPayments?.methodOfPayment || null,
        deferredPayment: customerDetailsPayments?.deferredPayment || '',
        methodOfPaymentVAT: customerDetailsPayments?.methodOfPaymentVAT || null,
        deferredPaymentVAT: customerDetailsPayments?.deferredPaymentVAT || '',
        additionalFiscalReference: (customerDetailsPayments?.additionalFiscalReference || []).map((additionalFiscalReference) => ({
          role: additionalFiscalReference.role,
          vatIdentificationNumber: additionalFiscalReference.vatIdentificationNumber,
        })),
      },
      personPayingTheCustomDuty: {
        identificationNumber: cd?.personPayingTheCustomDuty?.identificationNumber || '',
      },
    } as unknown as Customer;

    return customerDetailsInitialValues;
  };

  const form = useForm<CustomerViewPaymentsFormValues>({
    initialValues: buildFormValues(customerDetails),
    validate: zodResolver(customerPaymentsSchema),
    validateInputOnBlur: true,
  });

  return { form, buildFormValues };
};
